export default angular.module('cian.newbuild.filter.phoneParser', [])
  .directive('phoneParser', () => {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: (scope, elem, attrs, ngModelCtrl) => {
        ngModelCtrl.$parsers.push(viewValue => {
          // Разрешаем ввод вида: +7 (999) 111-22-33
          const transformed = viewValue.replace(/[^\d\s-+()]/g, '');

          if (transformed !== viewValue) {
            ngModelCtrl.$setViewValue(transformed);
            ngModelCtrl.$render();
          }

          // Сохраняем только цифры
          return transformed.replace(/\D/g, '') || null;
        });
      },
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/serp/directives/phone-parser.dir.js